import { AssertException } from '../assert.exception';

export class AssertIsNotNilException extends AssertException {
  constructor(message?: string) {
    super(message);

    Object.setPrototypeOf(this, AssertIsNotNilException.prototype);
  }
}
